import React, {SVGProps, useId} from 'react';

interface INewLogoIconProps extends SVGProps<SVGSVGElement> {
    size?: number | string;
}

export const NewLogoIcon = ({size = 16, width, height, ...props}: INewLogoIconProps) => {
    const svgWidth = width || size;
    const svgHeight = height || size;
    const idGrad = useId();
    const idClip = useId();

    return (
        <svg
            width={svgWidth}
            height={svgHeight}
            viewBox={'0 0 16 16'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
            {...props}
        >
            <defs>
                <radialGradient
                    id={idGrad}
                    cx={'0'}
                    cy={'0'}
                    r={'1'}
                    gradientUnits={'userSpaceOnUse'}
                    gradientTransform={'translate(16 15.6667) rotate(-180) scale(20.5 33.7089)'}
                >
                    <stop stopColor={'#E40F7E'} />
                    <stop offset={'0.53125'} stopColor={'#4A0348'} />
                    <stop offset={'0.925102'} stopColor={'#28282A'} />
                </radialGradient>
                <clipPath id={idClip}>
                    <path
                        d={
                            'M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z'
                        }
                        fill={'white'}
                    />
                </clipPath>
            </defs>

            <g clipPath={`url(#${idClip})`}>
                <path
                    d={
                        'M0 1.5C0 0.671573 0.671573 0 1.5 0H14.5C15.3284 0 16 0.671573 16 1.5V14.5C16 15.3284 15.3284 16 14.5 16H1.5C0.671573 16 0 15.3284 0 14.5V1.5Z'
                    }
                    fill={`url(#${idGrad})`}
                />
                <path
                    fillRule={'evenodd'}
                    clipRule={'evenodd'}
                    d={
                        'M3.74554 0L4.49928 0L3.65664 7.4008C3.42996 9.57813 4.32354 10.1717 5.71417 10.8278C6.73282 11.3088 7.61164 11.7239 7.61164 13.5909V16H6.8628V13.5914C6.8628 12.2154 6.37449 11.9843 5.40117 11.5255C4.22359 10.9713 2.61119 10.2077 2.91162 7.31382L3.74554 0ZM11.469 0L12.2238 0L13.0873 7.31051C13.3647 9.98713 12.0686 10.8306 10.5993 11.5249C9.62547 11.9843 9.13718 12.2149 9.13718 13.5909V16H8.38887V13.5914C8.38887 11.7248 9.26737 11.3096 10.2847 10.8286L10.2853 10.8284C11.6322 10.1927 12.5689 9.57373 12.3434 7.39751L11.469 0ZM8.00164 10.4028H7.99671C6.37943 10.4028 5.21821 9.77322 4.79655 9.10877C4.50337 8.55287 4.41081 7.91053 4.53492 7.29276L4.60263 6.77793H11.3957L11.4629 7.2922C11.5864 7.90989 11.4943 8.55189 11.2023 9.10821C10.7796 9.77321 9.6189 10.4028 8.00164 10.4028Z'
                    }
                    fill={'white'}
                />
            </g>
        </svg>
    );
};

export default NewLogoIcon;
